module.exports = __webpack_public_path__ + "img/u1.02c27a28.svg";